<template>
    <div class="main">
        <div class="head">
            <div>
                token：<button @click="tokenShow = !tokenShow" class="btn">{{ tokenShow ? '隐藏' : '显示' }}</button>
                url：<button @click="urlShow = !urlShow" class="btn">{{ urlShow ? '隐藏' : '显示' }}</button>
                <input v-show="lx == 168" type="file" class="file" ref="fileInput" @change="handleFileChange"
                    accept=".pdf,.ofd,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.bmp,.css,.js,.html,.txt,.zip">
                <button v-show="lx == 168" class="btn blue" @click="selectDir">查询</button>&nbsp;
                <button v-show="lx == 168" class="btn" @click="uploadFile">上传</button>&nbsp;
                <button v-show="lx == 168" class="btn orange" @click="downFile">下载</button>&nbsp;
                <button v-show="lx == 168" class="btn red" @click="deleteFile">删除</button>
            </div>
            <input type="text" v-show="urlShow" v-model.trim="base_url" @change="urlChange" class="txtContent"
                placeholder="请输入base_url" />
            <textarea class="txtToken" placeholder="请输入token" v-show="tokenShow" v-model.trim="token"
                @change="tokenChange" />
            <div>
                参数：
                <input type="text" class="txtContent" placeholder="参数1：projid | ec_id | tz_cd | id"
                    v-model.trim="param1">
                <input type="text" class="txtContent" placeholder="参数2：lx 等" v-model.trim="param2">
                <button @click="clear" class="btn black">清空</button>
            </div>
            <div>接口列表：</div>
        </div>

        <div class="body">
            <div class="body_top"></div>
            <table id="tbData">
                <thead>
                    <tr>
                        <th>序号</th>
                        <th>类型</th>
                        <th>接口名称</th>
                        <th>操作</th>
                        <th>接口说明</th>
                        <th>接口地址</th>
                    </tr>
                </thead>
                <tbody class="tbody">
                    <tr>
                        <td>1</td>
                        <td rowspan="4" class="center">批复</td>
                        <td>退到待初审</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Pf/ToDaiChuShen/{key1}?ucd={key2}')"
                                class="btnRun btn">初审</button>
                        </td>
                        <td>政务反馈前退回到待初审（ucd?：空:待初审，ucd:初审中，yuan:原初审人员初审中）</td>
                        <td>HttpPut：/api/Pf/ToDaiChuShen/{projid}?ucd={ucd?}</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>退到待审查</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Pf/ShenChaChange/{key1}/{key2}', false)"
                                class="btnRun btn">审查</button>
                        </td>
                        <td>复核前退回到待审查（lx: xian:到核查,shi:到市级待审查,shi2:核查后待审查，sheng:到省级待审查）</td>
                        <td>HttpPut：/api/Pf/ShenChaChange/{projid}/{lx}</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>退到待批复</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Pf/ToDaiPiFu/{key1}?ucd={key2}', false)"
                                class="btnRun btn">批复</button>
                        </td>
                        <td>政务反馈前退回到待批复（ucd?：空:待批复，ucd:批复中，yuan:原批复人员批复中，ti:审查中提到待批复）</td>
                        <td>HttpPut：/api/Pf/ToDaiPiFu/{projid}?ucd={ucd?}</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>退到待政务反馈确认</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Pf/ToQueRen/{key1}')" class="btnRun btn">确认</button>
                        </td>
                        <td>待归档到待政务反馈</td>
                        <td>HttpPut：/api/Pf/ToQueRen/{projid}</td>

                    </tr>
                    <tr>
                        <td>5</td>
                        <td rowspan="5" class="center">验收</td>
                        <td>退到待申请</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Ys/ToDaiShenQing/{key1}?lx={key2}', false)"
                                class="btnRun btn">申请</button>
                        </td>
                        <td>待确认前退回到待验收申请， lx?: '' | sheng | shi | xian ， 兼容转到不同的级别，非转需求不填参数2 </td>
                        <td>HttpPut：/api/Ys/ToDaiShenQing/{projid}?lx={lx?}</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>退回待验收</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Ys/ToDaiYanShou/{key1}')" class="btnRun btn">验收</button>
                        </td>
                        <td>待确认前退回到待验收</td>
                        <td>HttpPut：/api/Ys/ToDaiYanShou/{projid}</td>

                    </tr>
                    <tr>
                        <td>7</td>
                        <td>退到待确认</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Ys/ToQueRen/{key1}')" class="btnRun btn">确认</button>
                        </td>
                        <td>待归档退回到待确认</td>
                        <td>HttpPut：/api/Ys/ToQueRen/{projid}</td>

                    </tr>
                    <!-- <tr>
                    <td>7</td>
                    <td>验收下放区县</td>
                    <td>
                        <button @click="contentRun('/api/Yw/Ys/ToQuXian/{key1}')" class="btnRun">执行</button>
                    </td>
                    <td>验收申请下放区县</td>
                    <td>HttpPut：/api/Ys/ToQuXian/{projid}</td>

                </tr> -->
                    <tr>
                        <td>8</td>
                        <td>验收退回到批复流程</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Ys/ToPiFu/{key1}')" class="btnRun btn red">批复</button>
                        </td>
                        <td>验收归档前退回到批复待政务反馈确认（慎用）</td>
                        <td>HttpPut：/api/Ys/ToPiFu/{projid}</td>

                    </tr>
                    <tr>
                        <td>9</td>
                        <td>调整转新办</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Tz/TiaoZhengToXinBan/{key1}')"
                                class="btnRun btn red">新办</button>
                        </td>
                        <td>验收中的台账 调整类型 转成新办 ，并解除和上一个证的绑定关系 （办件表和 apply表信息 需要前台调整审批信息）</td>
                        <td>HttpPut：/api/Tz/TiaoZhengToXinBan/{ec_id}</td>

                    </tr>
                    <tr>
                        <td>10</td>
                        <td rowspan="4" class="center">台账</td>
                        <td>退回到草稿</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Tz/ToCaoGao/{key1}')"
                                class="btnRun btn orange">退回</button>
                        </td>
                        <td>台账入库前退回到草稿（来源是审批系统的不能处理）</td>
                        <td>HttpPut：/api/Tz/ToCaoGao/{ec_id}</td>

                    </tr>
                    <tr>
                        <td>11</td>
                        <td rowspan="2">代码检测查询与处理</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Tz/DaiJianCe/{key1}', false, 'GET')"
                                class="btnRun btn blue">查询</button>
                        </td>
                        <td>查询代码检测（通过EC_ID、TZ_CD（完全匹配）或统一社会信用代码及名称（模糊匹配）检测需要通过代码检测的数据</td>
                        <td>HttpGet：/api/Tz/DaiJianCe/{tz_cd}</td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Tz/TongGuoJC/{key1}')" class="btnRun btn">处理</button>
                        </td>
                        <td>通过代码检测（未通过检测或检测不到的，会修改JGMC为取水权人代码）</td>
                        <td>HttpPut：/api/Tz/TongGuoJC/{ec_id}</td>

                    </tr>
                    <tr>
                        <td>13</td>
                        <td>设置数据维护</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Tz/SetShuJuWeiHu/{key1}')"
                                class="btnRun btn red">维护</button>
                        </td>
                        <td>台账待审核之后 ，发证之前，设置为数据维护状态（发证中慎用）</td>
                        <td>HttpPut：/api/Tz/SetShuJuWeiHu/{ec_id}</td>

                    </tr>
                    <tr>
                        <td>14</td>
                        <td rowspan="3" class="center">流程</td>
                        <td>获取流程</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Lc/{key2}/{key1}', true, 'Get')"
                                class="btnRun btn blue">查询</button>
                        </td>
                        <td>获取审批、验收、台账流程的数据（ all | pf | ys | tz ）</td>
                        <td>HttpGet：/api/Lc/{lx}/{projid}</td>

                    </tr>
                    <tr>
                        <td>15</td>
                        <td>删除流程</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Lc/{key2}/{key1}', true, 'Delete')"
                                class="btnRun btn orange">删除</button>
                        </td>
                        <td>删除审批、验收、台账流程的数据（ pf | ys | tz ）</td>
                        <td>HttpDelete：/api/Lc/{lx}/{id}</td>

                    </tr>
                    <tr>
                        <td>16</td>
                        <td>恢复流程</td>
                        <td>
                            <button @click="contentRun('/api/Yw/Lc/{key2}/{key1}', true)" class="btnRun btn">恢复</button>
                        </td>
                        <td>恢复审批、验收、台账流程的数据（ pf | ys | tz ）</td>
                        <td>HttpPut：/api/Lc/{lx}/{id}</td>

                    </tr>
                </tbody>
            </table>
            <div class="body_bottom"></div>
        </div>
        <div class="bottom">
            <div>result：<span v-show="dataCount >= 0">查询出 {{ dataCount }} 条数据</span></div>
            <div>
                <textarea class="txtResult" placeholder="显示处理结果" v-model="result"></textarea>
            </div>
        </div>

    </div>

</template>

<script setup name="YwPage">
import { ref } from "vue";
import fetchApi from './fetchApi.js';
import { DateTime } from './public.js';
import { SM4Helper } from './SM4Helper.js'

const tokenShow = ref(false);
const token = ref("");
const base_url = ref("");
const urlShow = ref(false);
const param1 = ref("");
const param2 = ref("");
const param3 = ref("");
const result = ref("");
const dataCount = ref(-1);
const selectedFile = ref(null);
const fileInput = ref(null)
const sm4Key = DateTime.Now.ToString("yyyyMMdd");
const sm4 = new SM4Helper(sm4Key + sm4Key);

// 获取 lx 参数
const lx = ref(null)

// 获取 URL 参数
const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(param)
}
lx.value = getQueryParam('lx')

//取得token
token.value = localStorage.getItem("auth_token");
base_url.value = localStorage.getItem("base_url");

//设置token
function tokenChange() {
    localStorage.setItem("auth_token", token.value);
}
//设置url
function urlChange() {
    localStorage.setItem("base_url", base_url.value);
}
//执行 
//参数改成由url定制化
function contentRun(url, iskey2 = false, method = "PUT") {
    //验证
    if (!base_url.value || base_url.value.length < 5) {
        alert("请输入base_url");
        return;
    }
    if (!url || url.length < 5) {
        alert("请输入url");
        return;
    }
    //参数1为必填
    if (url.includes('{key1}')) {
        if (param1.value == "") {
            alert("请输入参数1");
            return;
        }
        url = url.replace('{key1}', param1.value);
    }
    //参数2为可以选填
    if (url.includes('{key2}')) {
        if (iskey2 && param2.value == "") {
            alert("请输入参数2");
            return;
        }
        url = url.replace('{key2}', param2.value);
    }

    //预留 参数3 一定可以选填
    if (url.includes('{key3}')) {
        url = url.replace('{key3}', param3.value);
    }
    //let fullUrl = `${baseURL}${url}`;
    let fullUrl = `${base_url.value.TrimEnd('/')}${url}`;
    fetchApi.request(fullUrl, { method: method }).then(res => {
        // result.value = JSON.stringify(res);
        const newRes = { time: DateTime.Now.format("yyyy-MM-dd HH:mm:ss"), ...res };

        result.value = JSON.stringify(newRes, null, 2)
        if (Array.isArray(res.data)) {
            dataCount.value = res.data.length;
        }
        else {
            dataCount.value = -1
        }
    });
}
function clear() {
    param1.value = ""
    param2.value = ""
    param3.value = ""
    result.value = ""
}
// function fileChange(event) {
//     const files = event.target.files;
//     if (files.length > 0) {
//         const file = files[0]; // 获取第一个文件
//         //console.log(file); // 打印文件信息

//         var reader = new FileReader();
//         reader.onload = function (evt) {
//             var base64 = evt.target.result
//             console.log(base64);
//         };
//         reader.readAsDataURL(file);
//     }
// }

function handleFileChange(event) {
    selectedFile.value = event.target.files[0]
}
async function uploadFile(event) {
    //const fileInput = document.getElementById('fileInput');

    if (param1.value == "") {
        alert("请填写路径");
        return;
    }

    const savePath = sm4.encrypt(param1.value);
    const file = selectedFile.value; //fileInput.files[0];

    if (!file) {
        alert("请选择文件");
        return;
    }

    // if (!savePath) {
    //     alert("请输入保存路径");
    //     return;
    // }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('savePath', savePath);

    try {
        let fullUrl = `${base_url.value.TrimEnd('/')}/api/Yw/SetData`;
        fetchApi.request(fullUrl, { method: 'POST', body: formData, formData: true }).then(res => {
            // alert(res.msg);
            result.value = JSON.stringify(res, null, 2)
            if (1 == res.state) {
                selectedFile.value = null
                fileInput.value.value = ''
            }
        });
    }
    catch (error) {
        alert("上传失败，" + error.message);

    }
}
async function selectDir(event) {
    if (param1.value == "") {
        alert("请填写路径");
        return;
    }
    const cs1 = sm4.encrypt(param1.value);
    const cs2 = param2.value == "" ? "" : sm4.encrypt(param2.value);
    const cs3 = param3.value == "" ? "" : sm4.encrypt(param3.value);
    let fullUrl = `${base_url.value.TrimEnd('/')}/api/Yw/GetDatas`;
    fetchApi.post(fullUrl, { cs1: cs1, cs2: cs2, cs3: cs3 }).then(res => {
        result.value = JSON.stringify(res, null, 2)
        if (Array.isArray(res.data)) {
            dataCount.value = res.data.length;
        }
        else {
            dataCount.value = -1
        }
    });
}
async function downFile(event) {
    // ECB模式
    if (param1.value == "") {
        alert("请填写路径");
        return;
    }
    //
    const savePath = sm4.encrypt(param1.value);
    try {
        let fullUrl = `${base_url.value.TrimEnd('/')}/api/Yw/GetData`;
        fetchApi.request(fullUrl, { method: 'POST', body: { cs1: savePath }, download: 1 }).then(blob => {
            if (!blob || blob.size === 0) {
                throw new Error('服务器返回空文件，请检查数据源'); //
            }
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = param1.value.split(/[\\/]/).pop();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        });
    }
    catch (error) {
        alert("下载失败，" + error.message);
    }
}
async function deleteFile(event) {

    if (param1.value == "") {
        alert("请填写路径");
        return;
    }
    if (param2.value == "" || (param2.value != "file" && param2.value != "dir")) {
        alert("请填写类型");
        return;
    }
    const cs1 = sm4.encrypt(param1.value);
    const cs2 = sm4.encrypt(param2.value);
    const cs3 = param3.value == "" ? "" : sm4.encrypt(param3.value);
    let fullUrl = `${base_url.value.TrimEnd('/')}/api/Yw/PutData`;
    fetchApi.put(fullUrl, { cs1: cs1, cs2: cs2, cs3: cs3 }).then(res => {
        result.value = JSON.stringify(res, null, 2)
        if (Array.isArray(res.data)) {
            dataCount.value = res.data.length;
        }
        else {
            dataCount.value = -1
        }
    });
}

</script>

<style scoped>
.main {
    position: relative;
    width: 100%;
    box-sizing: border-box;
}

.head {

    position: fixed;
    padding-top: 10px;
    background-color: #FFF;
    width: 100%;
    top: 0px;
}

.body {
    /* position:absolute; */
    box-sizing: border-box;
    /* margin-top: 93px; */
    width: 100%;

}

.body_top {
    height: 100px;
}

.body_bottom {
    height: 212px;
    max-height: 32vh;
}

.bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 5px;
    background-color: #FFF;
}

button {
    cursor: pointer;
}

.txtToken {
    width: calc(100% - 30px);
    height: 100px;
    margin-top: 5px;
}

.txtContent {
    width: 300px;
    height: 30px;
    margin-top: 5px;
    margin-right: 5px;
}

.txtResult {
    width: calc(100% - 30px);
    margin-top: 5px;
    height: 180px;
    max-height: 25vh;
}

.btnRun {
    /* position: absolute;
    right: 8px; */
}

#tbData thead tr th:nth-child(1) {
    width: 50px;
}

#tbData thead tr th:nth-child(2) {
    width: 100px;
}

#tbData thead tr th:nth-last-child(3) {
    width: 60px;
}

/* #tbData thead tr th:last-child {
    width: 80px;
} */
.center {
    text-align: center;
}

#tbData tbody tr td:nth-child(1) {
    text-align: center !important;
}

/*
#tbData tbody tr td:nth-child(2) {
    text-align: center !important;
}
*/
/* #tbData tbody tr td:last-child {
    text-align: center !important;
}  */

#tbData tbody tr td:nth-last-child(3) {
    text-align: center !important;
}

@media (max-width: 999px) {

    #tbData th:last-child,
    #tbData td:last-child {
        display: none;
    }
}

/* 当页面宽度小于600px时 */
@media (max-width: 599px) {

    #tbData th:last-child,
    #tbData td:last-child,
    #tbData th:nth-last-child(2),
    #tbData td:nth-last-child(2) {
        display: none;
    }

    .txtContent {
        width: 33%;
    }

    .body_bottom {

        /* max-height: 30vh; */
    }
}


table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
}

th,
td {
    border: 1px solid #ddd;
    padding: 5px;
    text-align: left;
}

th {
    background-color: #f5f5f5;
    font-weight: bold;
    text-align: center;
}

tr:nth-child(even) {
    background-color: #f9f9f9;
}

tr:hover {
    background-color: #f0f0f0;
}

.idxnum {
    text-align: center;
}

.tbody {
    height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
}

.btn {
    display: inline-block;
    vertical-align: middle;
    height: 25px;
    line-height: 25px;
    background-color: #009688;
    color: rgb(255, 255, 255);
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    border-image: initial;
    padding: 0px 7px;
    white-space: nowrap;
    border-radius: 3px;
}

.blue {
    background-color: #1E9FFF
}

.blue2 {
    background-color: #31BDEC
}

.red {
    background-color: #FF5722
}

.green2 {
    background-color: #5FB878
}

.orange {
    background-color: #FFB800
}

.black {
    background-color: #393D49
}

.file {
    margin-left: 10px;
}
</style>
